import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	threadTypeLabel: {
		id: 'search-result.thread-type-label',
		defaultMessage: 'Thread',
		description: 'Message metadata label',
	},
	messageTypeLabel: {
		id: 'search-result.message-type-label',
		defaultMessage: 'Message',
		description: 'Message metadata label',
	},
	lastActive: {
		id: 'search-result.message-last-active',
		defaultMessage: 'Last active {formattedDate}',
		description: 'Message metadata label',
	},
	attachedDateLabel: {
		id: 'search-result.attachments.attached-date.label',
		defaultMessage: 'Attached {formattedDate}',
		description: 'Attachments showin the date the attachment was added',
	},
	privateChannelLabel: {
		id: 'search-result.private-channel-label',
		defaultMessage: 'Private Channel',
		description: 'Private channel metadata label',
	},
	memberCount: {
		id: 'search-page.results.product-results.third-party.message-search-result.member-count',
		defaultMessage: '{count, plural, one {# member} other {# members}}',
		description: 'Use to describe the number of members in a conversation',
	},
	smartlinkAttachmentsExpandButtonLabel: {
		id: 'search-page.results.product-results.third-party.message-search-result.smartlink-attachments-expand-button-label',
		defaultMessage: '{count, plural, one {# link} other {# links}}',
		description: 'Use to describe the number of links shared in a conversation',
	},

	fileAttachmentsExpandButtonLabel: {
		id: 'search-page.results.product-results.third-party.message-search-result.file-attachments-expand-button-label',
		defaultMessage: '{count, plural, one {# attachment} other {# attachments}}',
		description: 'Use to describe the number of file attachments shared in a conversation',
	},
});
